<template>
  <div class="accounts">
    <el-card shadow="never" class="accounts-card">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="入驻申请审核" name="apply">
          <el-table :data="applyList" style="width: 100%;" border stripe v-loading="applyLoading">
            <el-table-column prop="id" label="申请ID" width="100" />
            <el-table-column prop="name" label="分身名称" min-width="160" />
            <el-table-column prop="contact" label="联系人" width="180" />
            <el-table-column prop="deposit" label="保证金" width="120">
              <template slot-scope="scope">
                <span class="price-bold">¥{{ scope.row.deposit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status_code === 0 ? 'danger' : 'success'" size="small">{{ scope.row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
              <template slot-scope="scope">
                <template v-if="scope.row.status_code === 0">
                  <el-button type="text" style="color: #67c23a;" size="small" @click="handleApplyAction(scope.row, 'approve')">通过</el-button>
                  <el-button type="text" style="color: #E4393C;" size="small" @click="handleApplyAction(scope.row, 'reject')">驳回</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrap">
            <span>共 {{ applyTotal }} 条记录</span>
            <el-pagination background layout="prev, pager, next" :total="applyTotal" :page-size="applyLimit" :current-page.sync="applyPage" @current-change="fetchApplyList" />
          </div>
        </el-tab-pane>

        <el-tab-pane label="已入驻分身管理" name="list">
          <div class="tab-header">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddAccount">添加分身</el-button>
          </div>
          <el-table :data="accountList" style="width: 100%;" border stripe v-loading="branchLoading">
            <el-table-column prop="id" label="分身ID" width="100" />
            <el-table-column prop="name" label="分身名称" min-width="140" />
            <el-table-column prop="login_account" label="登录账号" width="120" />
            <el-table-column prop="contact_name" label="负责人" width="100" />
            <el-table-column prop="deposit" label="保证金" width="140">
              <template slot-scope="scope">
                <span class="price-bold">¥{{ scope.row.deposit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status_code === 2 ? 'warning' : 'success'" size="small">{{ scope.row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="入驻时间" width="140">
              <template slot-scope="scope">{{ scope.row.joinTime | formatDateTime }}</template>
            </el-table-column>
            <el-table-column label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" style="color: #409EFF;" size="small" @click="handleEditAccount(scope.row)">编辑</el-button>
                <el-button type="text" style="color: #E4393C;" size="small" @click="handleRefundDeposit(scope.row)">退保证金</el-button>
                <el-button v-if="scope.row.status_code === 2" type="text" style="color: #409EFF;" size="small" @click="handleRenew(scope.row)">续约</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrap">
            <span>共 {{ branchTotal }} 条记录</span>
            <el-pagination background layout="prev, pager, next" :total="branchTotal" :page-size="branchLimit" :current-page.sync="branchPage" @current-change="fetchBranchList" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 添加分身对话框 -->
    <el-dialog title="添加分身账号" :visible.sync="addDialogVisible" width="560px" :close-on-click-modal="false">
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="110px">
        <el-form-item label="分身名称" prop="shop_name">
          <el-input v-model="addForm.shop_name" placeholder="请输入分身商城名称" maxlength="100" />
        </el-form-item>
        <el-form-item label="负责人姓名" prop="contact_name">
          <el-input v-model="addForm.contact_name" placeholder="请输入负责人姓名" maxlength="20" />
        </el-form-item>
        <el-form-item label="负责人手机号" prop="contact_phone">
          <el-input v-model="addForm.contact_phone" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>
        <el-form-item label="登录账号" prop="login_account">
          <el-input v-model="addForm.login_account" placeholder="分身商登录用的账号（英文/数字）" maxlength="50" />
        </el-form-item>
        <el-form-item label="登录密码" prop="login_password">
          <el-input v-model="addForm.login_password" type="password" placeholder="请输入登录密码（至少6位）" maxlength="32" show-password />
        </el-form-item>
        <el-form-item label="营业执照" prop="business_license">
          <div class="upload-wrap">
            <el-input v-model="addForm.business_license" placeholder="营业执照图片URL" style="flex: 1;" />
            <el-upload
              class="upload-btn"
              action="https://api-lefeng365.linhebj.top/api/v1/manger/upload"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleLicenseUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/*"
            >
              <el-button size="small" icon="el-icon-upload">上传</el-button>
            </el-upload>
          </div>
          <img v-if="addForm.business_license" :src="addForm.business_license" class="img-preview" />
        </el-form-item>
        <el-form-item label="公众号AppID" prop="appid">
          <el-input v-model="addForm.appid" placeholder="微信公众号AppID" maxlength="50" />
        </el-form-item>
        <el-form-item label="公众号密钥" prop="app_secret">
          <el-input v-model="addForm.app_secret" placeholder="微信公众号AppSecret" maxlength="100" show-password />
        </el-form-item>
        <el-form-item label="公众号名称" prop="wechat_name">
          <el-input v-model="addForm.wechat_name" placeholder="微信公众号名称" maxlength="100" />
        </el-form-item>
        <el-form-item label="支付商户号" prop="mch_id">
          <el-input v-model="addForm.mch_id" placeholder="微信支付商户号（mch_id）" maxlength="32" />
        </el-form-item>
        <el-form-item label="支付密钥" prop="key">
          <el-input v-model="addForm.key" placeholder="微信支付API密钥（key）" maxlength="255" show-password />
        </el-form-item>
        <el-form-item label="保证金(¥)" prop="deposit_amount">
          <el-input-number v-model="addForm.deposit_amount" :min="0" :precision="2" controls-position="right" style="width: 100%;" placeholder="请输入保证金金额" />
        </el-form-item>
        <el-form-item label="分红比例(%)" prop="dividend_ratio">
          <el-select v-model="addForm.dividend_ratio" placeholder="请选择分红比例" style="width: 100%;">
            <el-option v-for="r in [50, 60, 70, 80, 90, 100]" :key="r" :label="r + '%'" :value="r" />
          </el-select>
        </el-form-item>
        <el-form-item label="合同到期时间" prop="expire_time">
          <el-date-picker v-model="addForm.expire_time" type="date" placeholder="选择到期时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="addLoading" @click="submitAddAccount">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑分身对话框 -->
    <el-dialog title="编辑分身账号" :visible.sync="editDialogVisible" width="560px" :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="110px">
        <el-form-item label="分身名称" prop="shop_name">
          <el-input v-model="editForm.shop_name" placeholder="请输入分身商城名称" maxlength="100" />
        </el-form-item>
        <el-form-item label="负责人姓名" prop="contact_name">
          <el-input v-model="editForm.contact_name" placeholder="请输入负责人姓名" maxlength="20" />
        </el-form-item>
        <el-form-item label="负责人手机号" prop="contact_phone">
          <el-input v-model="editForm.contact_phone" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>
        <el-form-item label="营业执照" prop="business_license">
          <div class="upload-wrap">
            <el-input v-model="editForm.business_license" placeholder="营业执照图片URL" style="flex: 1;" />
            <el-upload
              class="upload-btn"
              action="https://api-lefeng365.linhebj.top/api/v1/manger/upload"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleEditLicenseUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/*"
            >
              <el-button size="small" icon="el-icon-upload">上传</el-button>
            </el-upload>
          </div>
          <img v-if="editForm.business_license" :src="editForm.business_license" class="img-preview" />
        </el-form-item>
        <el-form-item label="公众号AppID" prop="appid">
          <el-input v-model="editForm.appid" placeholder="微信公众号AppID" maxlength="50" />
        </el-form-item>
        <el-form-item label="公众号密钥" prop="app_secret">
          <el-input v-model="editForm.app_secret" placeholder="微信公众号AppSecret" maxlength="100" show-password />
        </el-form-item>
        <el-form-item label="公众号名称" prop="wechat_name">
          <el-input v-model="editForm.wechat_name" placeholder="微信公众号名称" maxlength="100" />
        </el-form-item>
        <el-form-item label="支付商户号" prop="mch_id">
          <el-input v-model="editForm.mch_id" placeholder="微信支付商户号（mch_id）" maxlength="32" />
        </el-form-item>
        <el-form-item label="支付密钥" prop="key">
          <el-input v-model="editForm.key" placeholder="微信支付API密钥（key）" maxlength="255" show-password />
        </el-form-item>
        <el-form-item label="保证金(¥)" prop="deposit_amount">
          <el-input-number v-model="editForm.deposit_amount" :min="0" :precision="2" controls-position="right" style="width: 100%;" placeholder="请输入保证金金额" />
        </el-form-item>
        <el-form-item label="分红比例(%)" prop="dividend_ratio">
          <el-select v-model="editForm.dividend_ratio" placeholder="请选择分红比例" style="width: 100%;">
            <el-option v-for="r in [50, 60, 70, 80, 90, 100]" :key="r" :label="r + '%'" :value="r" />
          </el-select>
        </el-form-item>
        <el-form-item label="合同到期时间" prop="expire_time">
          <el-date-picker v-model="editForm.expire_time" type="date" placeholder="选择到期时间" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editLoading" @click="submitEditAccount">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getApplyList, approveApply, rejectApply, getBranchList, createAccount, updateAccount, refundDeposit, renewBranch } from '@/api'

export default {
  name: 'Accounts',
  data() {
    return {
      activeTab: 'apply',
      applyList: [], applyTotal: 0, applyPage: 1, applyLimit: 10, applyLoading: false,
      accountList: [], branchTotal: 0, branchPage: 1, branchLimit: 10, branchLoading: false,
      // 添加分身
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        shop_name: '',
        contact_name: '',
        contact_phone: '',
        login_account: '',
        login_password: '',
        business_license: '',
        appid: '',
        app_secret: '',
        wechat_name: '',
        mch_id: '',
        key: '',
        deposit_amount: 0,
        dividend_ratio: 50,
        expire_time: ''
      },
      addRules: {
        shop_name: [{ required: true, message: '请输入分身名称', trigger: 'blur' }],
        contact_name: [{ required: true, message: '请输入负责人姓名', trigger: 'blur' }],
        contact_phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        login_account: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]{3,50}$/, message: '账号由字母/数字/下划线组成，至少3位', trigger: 'blur' }
        ],
        login_password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        deposit_amount: [{ required: true, message: '请输入保证金金额', trigger: 'blur' }],
        dividend_ratio: [{ required: true, message: '请选择分红比例', trigger: 'change' }]
      },
      // 编辑分身
      editDialogVisible: false,
      editLoading: false,
      editForm: {
        id: null,
        shop_name: '',
        contact_name: '',
        contact_phone: '',
        business_license: '',
        appid: '',
        app_secret: '',
        wechat_name: '',
        mch_id: '',
        key: '',
        deposit_amount: 0,
        dividend_ratio: 50,
        expire_time: ''
      },
      editRules: {
        shop_name: [{ required: true, message: '请输入分身名称', trigger: 'blur' }],
        contact_name: [{ required: true, message: '请输入负责人姓名', trigger: 'blur' }],
        contact_phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        deposit_amount: [{ required: true, message: '请输入保证金金额', trigger: 'blur' }],
        dividend_ratio: [{ required: true, message: '请选择分红比例', trigger: 'change' }]
      }
    }
  },
  computed: {
    uploadHeaders() {
      const token = localStorage.getItem('admin_token')
      return token ? { Authorization: `Bearer ${token}` } : {}
    }
  },
  mounted() {
    this.fetchApplyList()
  },
  methods: {
    handleTabChange(tab) {
      if (tab.name === 'list') this.fetchBranchList()
    },
    fetchApplyList() {
      this.applyLoading = true
      getApplyList({ page: this.applyPage, limit: this.applyLimit }).then(res => {
        this.applyList = res.list || []
        this.applyTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取入驻申请列表失败')
      }).finally(() => { this.applyLoading = false })
    },
    fetchBranchList() {
      this.branchLoading = true
      getBranchList({ page: this.branchPage, limit: this.branchLimit }).then(res => {
        this.accountList = res.list || []
        this.branchTotal = res.total || 0
      }).catch(() => {
        this.$message.error('获取分身列表失败')
      }).finally(() => { this.branchLoading = false })
    },
    handleApplyAction(row, action) {
      const actionText = action === 'approve' ? '通过' : '驳回'
      this.$confirm(`确认${actionText}该入驻申请？`, '审核确认', { type: action === 'approve' ? 'success' : 'warning' }).then(() => {
        const rawId = parseInt(row.id.replace('APP-', ''))
        const apiCall = action === 'approve' ? approveApply({ id: rawId }) : rejectApply({ id: rawId })
        apiCall.then(() => {
          this.$message.success(`已${actionText}`)
          this.fetchApplyList()
        }).catch(() => { this.$message.error(`${actionText}失败`) })
      }).catch(() => {})
    },
    handleRefundDeposit(row) {
      this.$confirm('确认退还保证金？该操作不可撤销', '退保证金', { type: 'warning' }).then(() => {
        const rawId = parseInt(row.id.replace('SID-', ''))
        refundDeposit({ id: rawId }).then(() => {
          this.$message.success('保证金退还成功')
          this.fetchBranchList()
        }).catch(() => { this.$message.error('退还失败') })
      }).catch(() => {})
    },
    handleRenew(row) {
      this.$confirm(`确认为 ${row.name} 续约？`, '续约确认', { type: 'info' }).then(() => {
        const rawId = parseInt(row.id.replace('SID-', ''))
        renewBranch({ id: rawId }).then(() => {
          this.$message.success('续约成功')
          this.fetchBranchList()
        }).catch(() => { this.$message.error('续约失败') })
      }).catch(() => {})
    },
    // ========== 添加分身 ==========
    handleAddAccount() {
      this.addForm = {
        shop_name: '',
        contact_name: '',
        contact_phone: '',
        login_account: '',
        login_password: '',
        business_license: '',
        appid: '',
        app_secret: '',
        wechat_name: '',
        mch_id: '',
        key: '',
        deposit_amount: 0,
        dividend_ratio: 50,
        expire_time: ''
      }
      if (this.$refs.addForm) this.$refs.addForm.resetFields()
      this.addDialogVisible = true
    },
    submitAddAccount() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return
        this.addLoading = true
        createAccount(this.addForm).then(() => {
          this.$message.success('分身账号添加成功')
          this.addDialogVisible = false
          this.fetchBranchList()
        }).catch(err => {
          this.$message.error(err.message || '添加失败')
        }).finally(() => {
          this.addLoading = false
        })
      })
    },
    // ========== 营业执照上传 ==========
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    handleLicenseUploadSuccess(response) {
      if (response.result === 'ok') {
        this.addForm.business_license = response.message
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    handleEditLicenseUploadSuccess(response) {
      if (response.result === 'ok') {
        this.editForm.business_license = response.message
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    // ========== 编辑分身 ==========
    handleEditAccount(row) {
      // 需要从后端获取完整信息，这里先用列表数据 + 扩展字段
      // 通过 getBranchList 返回的 raw_id 来请求详情（如果后端有详情接口的话）
      // 目前后端没有详情接口，需要新增。这里先展示一个简单的编辑窗口，请确保 branchList 返回了足够字段
      this.editForm = {
        id: row.raw_id,
        shop_name: row.name || '',
        contact_name: row.contact_name || '',
        contact_phone: row.contact_phone || '',
        business_license: row.business_license || '',
        appid: row.appid || '',
        app_secret: row.app_secret || '',
        wechat_name: row.wechat_name || '',
        mch_id: row.mch_id || '',
        key: row.key || '',
        deposit_amount: parseFloat(row.deposit) || 0,
        dividend_ratio: parseInt(row.dividend_ratio) || 50,
        expire_time: row.expireTime || ''
      }
      if (this.$refs.editForm) this.$refs.editForm.resetFields()
      this.editDialogVisible = true
    },
    submitEditAccount() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        this.editLoading = true
        updateAccount(this.editForm).then(() => {
          this.$message.success('分身信息更新成功')
          this.editDialogVisible = false
          this.fetchBranchList()
        }).catch(err => {
          this.$message.error(err.message || '更新失败')
        }).finally(() => {
          this.editLoading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.accounts-card { border-radius: 8px; }
.price-bold { font-weight: bold; }
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
.tab-header { margin-bottom: 16px; }
.dialog-footer { text-align: right; }
.upload-wrap { display: flex; align-items: center; gap: 10px; }
.upload-btn { flex-shrink: 0; }
.img-preview { margin-top: 8px; max-width: 200px; max-height: 120px; border-radius: 4px; border: 1px solid #dcdfe6; }
</style>
